// extracted by mini-css-extract-plugin
export var content = "_9o-3";
export var list = "_9o-4";
export var settingsContent = "_9o-7";
export var settingsPanel = "_9o-8";
export var state = "_9o-6";
export var triggerBadge = "_9o-2";
export var triggerButton = "_9o-1";
export var triggerShell = "_9o-0";
export var unreadDot = "_9o-5";